export default {
      id: "issue-card-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#issue-card",
      toString: function () {
        return this.url;
      }
    }